"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("./index");
String.prototype.asDate = function () {
    return index_1.DateUtil.serverDateToDate(this);
};
String.prototype.equals = function (other) {
    if (other instanceof Date) {
        var ds = other.asServerString();
        return ds === this;
    }
    else
        return this === other;
};
Date.prototype.asServerString = function () {
    return index_1.DateUtil.toServerDateMinimal(this);
};
Date.prototype.asSimpleDateString = function () {
    return index_1.DateUtil.formatDate(this, "DD-MM-YYYY", "en");
};
Date.prototype.asDate = function () {
    return this;
};
var DateEquals = Date.prototype.equals;
Date.prototype.equals = function (other) {
    if (other && typeof (other) === "string") {
        var ds = this.asServerString();
        return ds === other;
    }
    else
        return this === other;
};
String.prototype.format = function () {
    var formatted = this;
    for (var i = 0; i < arguments.length; i++) {
        var regexp = new RegExp("\\{" + i + "\\}", "gi");
        formatted = formatted.replace(regexp, arguments[i]);
    }
    return formatted;
};
//# sourceMappingURL=ServerDate.js.map